export default (el) => el.outerHTML;
